
import Vue from "vue";
import VueRouter from "vue-router";

Vue.use(VueRouter);
const routes = [
  {
    path: "/",
    name: "applyBlueSquareNew",
    component: () => import("../views/ApplyNew.vue"),
  },
  {
    path: "/infoBlueSquareNew",
    name: "infoBlueSquareNew",
    component: () => import("../views/infoBlueSquareNew.vue"),
  },
  {
    path: "/applyWait",
    name: "applyWait",
    component: () => import("../views/applyWait.vue"),
  },

  
];
const router = new VueRouter({
  routes,
});
// 设置页面标题的导航守卫
router.beforeEach((to, from, next) => {
  if (to.meta.title) {
    document.title = to.meta.title;
  }
  next();
});
export default router;
